import { FileText, CheckCircle2, CreditCard, Heart, Crown, Check } from "lucide-react";

const STEPS = [
  { icon: FileText, title: "Submit Your Request", body: "Fill out the form with your service, date, time, your info & photos of your hair." },
  { icon: CheckCircle2, title: "Confirmation", body: "I'll review your request and confirm your appointment within 24 hours." },
  { icon: CreditCard, title: "Pay Your Deposit", body: "A $15 nonrefundable deposit is required to secure your spot — pay by card right from your approval email." },
  { icon: Heart, title: "Get Ready", body: "You'll receive a confirmation with all the details. See you soon! 💜" },
];

const NOTES = [
  "$15 nonrefundable deposit (applies to total) — transferable ONCE with at least 12 hours notice",
  "Cancellations or reschedules need at least 12 hours notice",
  "15-minute grace period, then a late fee may apply",
  "No same-day appointments (night before allowed)",
  "Payments: Cash, Apple Pay, Chime, Cash App, Card, Venmo",
  "Mobile appointments available — travel fees apply",
  "No-shows forfeit the deposit + $25 fee to rebook",
];

export const ProcessCards = () => (
  <div className="process-grid" data-testid="booking-process">
    <div className="notepad">
      <h3><Crown className="np-crown" /> The Booking Process <span className="np-heart">♡</span></h3>
      {STEPS.map((s, i) => (
        <div className="np-step" key={s.title}>
          <span className="np-icon"><s.icon /></span>
          <div>
            <b>{i + 1}. {s.title}</b>
            <p>{s.body}</p>
          </div>
        </div>
      ))}
    </div>
    <div className="notepad dark">
      <h3><Crown className="np-crown" /> Important Notes <span className="np-heart">♡</span></h3>
      <ul className="np-notes">
        {NOTES.map((n) => (
          <li key={n}><Check /> {n}</li>
        ))}
      </ul>
    </div>
  </div>
);
